<template>
  <div class="paw-install-award">
    <div class="paw-install-award-shadow" @click="close"></div>
    <div class="paw-install-award-main">
      <div class="main-text">
      <p style="white-space:break-spaces;line-height: 1.5;" v-html="letter.v3LaunchFromDesktopAndRewardToMailbox"></p>
      </div>
   
      <a href="javascript:;" class="main-close" @click="close">
        {{ letter.popupConfirm }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { clickButton } from '@plugins/biPoint/_configWebstoreV1';

export default {
  name: 'PwaInstallAwardPopup',
  emits: ['install', 'close'],
  computed: {
    ...mapState({
      letter: state => state.letter
    })
  },
  methods: {
    install() {
      this.$emit('install');
    },
    close() {
      // 打点上报
      clickButton({
        btnName: 'close_pwa_install_popup',
        locationKey: this.$route.meta.pageName
      });
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.paw-install-award {
  z-index: 11;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
  &-main {
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    @psetbg ('pwa-install-popup-bg.png');

    font-size: 20px;
    color: #fff;

    .main {
      &-text {
        margin-top: 164px;
        padding: 0 22px;
        font-size: 24px;
        p {
          line-height: 120%;
        }
        p:nth-child(1) {
          margin-bottom: 16px;
          color: #fff;
        }
        p:nth-child(2) {
          margin-bottom: 28px;
          // 文字渐变色
          font-weight: bold;
          background-image: linear-gradient(to bottom, #fffdd0, #fff84d);
          -webkit-background-clip: text;
          color: transparent; /* Fallback for non-webkit browsers */
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      &-install,
      &-close {
        display: block;
        margin: auto;
        text-align: center;
      }
      &-install {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 22px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        @psetbg ('pwa-install-popup-btn.png');
        line-height: 30px;
        font-size: 24px;
        font-weight: bold;
        color: #ffffff;
      }
      &-close {
       display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 22px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        @psetbg ('pwa-install-popup-btn.png');
        line-height: 30px;
        font-size: 24px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
}
</style>
